import { render, staticRenderFns } from "./StockCntInfo.vue?vue&type=template&id=36aed7f2&"
import script from "./StockCntInfo.vue?vue&type=script&lang=ts&"
export * from "./StockCntInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports